import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container pb-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.syncDigitalTwin')) + "\n    ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-rocket-launch",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.syncTwins
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sync')) + "\n      ")])];
      },
      proxy: true
    }])
  }, [_c(VForm, {
    ref: "createForm",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pt-2 pb-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("\n            " + _vm._s(_vm.orgTwin.title) + "\n            "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.orgTwin.id) + ")")])])])], 1), _vm.orgTwinStates === null ? [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 50,
      "width": 3,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1)], 1)] : [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-0",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.digitalTwins.head')))])]), _c(VExpansionPanelContent, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: _vm.twinSearch,
      callback: function ($$v) {
        _vm.twinSearch = $$v;
      },
      expression: "twinSearch"
    }
  }), _c('core-dtwin-tree-selection', {
    ref: "twin-tree",
    attrs: {
      "searchEnabled": "",
      "searchTerm": _vm.twinSearch,
      "selectedTwins": _vm.syncingTwins,
      "selectionObjectFilter": e => e.id !== _vm.orgTwin.id
    },
    on: {
      "deselectedTwin": _vm.syncingTwinDeselected,
      "selectedTwin": _vm.syncingTwinSelected
    }
  })], 1)], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.errornousTwinId > 0 ? [_c('span', {
    staticClass: "danger--text text-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.syncPermissionError')) + "\n              ")])] : _vm._e(), _vm._l(_vm.syncingTwins, function (twin, i) {
    return _c('span', {
      key: `twin-sync-${i}`,
      staticClass: "mr-2"
    }, [_c('router-link', {
      class: _vm.errornousTwinId === twin.id ? 'danger--text text-bold' : '',
      attrs: {
        "to": `/digitaltwin-mgmt/${twin.id}`
      }
    }, [_vm._v("\n                " + _vm._s(twin.title) + "\n              ")]), _c('span', {
      class: _vm.errornousTwinId === twin.id ? 'danger--text text-bold' : '',
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("\n                (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(twin.id) + ")\n              ")])], 1);
  })], 2), _c(VCol, {
    staticClass: "pt-2 pb-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.syncTwinText'))
    }
  })])], 1), _c(VRow, [_c(VCol, {
    staticClass: "pt-6 pb-0 my-0 text-bold",
    attrs: {
      "cols": "12"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-file-alt")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n          ")], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.twinMetaItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "chips": "",
      "multiple": "",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: _vm.syncMetaData,
      callback: function ($$v) {
        _vm.syncMetaData = $$v;
      },
      expression: "syncMetaData"
    }
  })], 1)], 1), _vm.orgTwinStates.length > 0 ? _c(VRow, [_c(VCol, {
    staticClass: "pt-6 my-0 text-bold",
    attrs: {
      "cols": "12"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-network-wired")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n          ")], 1), _c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.syncTwinStateText')))])])], 1) : _vm._e(), _vm._l(_vm.orgTwinStates, function (state, i) {
    return _c(VRow, {
      key: `state-sync-${i}`
    }, [_c(VCol, {
      staticClass: "py-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "text-bold py-0 my-0"
    }, [_vm._v(_vm._s(state.properties.title) + " (" + _vm._s(state.key) + ")")])]), _c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c(VAutocomplete, {
      attrs: {
        "items": _vm.stateMetaItems,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "chips": "",
        "multiple": "",
        "hide-details": "",
        "single-line": ""
      },
      model: {
        value: _vm.statesSync[state.key],
        callback: function ($$v) {
          _vm.$set(_vm.statesSync, state.key, $$v);
        },
        expression: "statesSync[state.key]"
      }
    })], 1)], 1);
  })]], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };